import React from 'react';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

const CustomAlert = (props:any) => {
  const useStyle = makeStyles((theme) => ({
    snackbarRoot: {
      top: 48,
    },
    root: {
      padding: theme.spacing(1, 4),
      fontSize: '1.25rem',
      "& .MuiAlert-icon": {
        fontSize: '1.25rem',
      },
    },
  }));
  const classes = useStyle();
  const Alert = (props) => {
    return <MuiAlert icon={props.icon && props.icon} elevation={0} variant="filled" {...props} />;
  };

  return (
    <Snackbar
      className={classes.snackbarRoot}
      {...props}

    >
      <Alert className={classes.root} icon={props.icon && props.icon} severity={props.alertseverity}>
        {props.children}
      </Alert>
    </Snackbar>
  );
}

export default CustomAlert;